import React from 'react';
import { Chip } from '@mui/material';
import { BookingStatus, CancelBookingPayment, useBookingStatus } from './utils';
import { BookingStatusRound } from './BookingsFilters/BookingFilters.styled';

export interface BookingStatusInfoProps {
  status: BookingStatus | CancelBookingPayment;
  small?: boolean;
  index?: number;
}

const BookingStatusInfo = ({ status, small, index }: BookingStatusInfoProps) => {
  const { statusColor, statusText } = useBookingStatus(status);

  if (small) {
    return (
      <BookingStatusRound
        bgColor={statusColor}
        index={index}
      />
    );
  }
  return (
    <Chip
      label={statusText}
      sx={{ backgroundColor: statusColor, color: 'white' }}
      size='small'
    />
  );
};

export default React.memo(BookingStatusInfo);
